import { FOCUSABLES_SELECTOR, isElementFocusable } from './is-focusable';

export default function toggleElement( elementOrId, toggle ) {
	if ( ! elementOrId ) {
		return;
	}

	let target, targetId;
	if ( typeof elementOrId === 'string' ) {
		targetId = elementOrId;
		target = document.getElementById( targetId );
	} else {
		target = elementOrId;
		targetId = target.id;
	}

	if ( ! target ) {
		return;
	}

	// Get the controls for this element
	const controls = document.querySelectorAll( `[aria-controls="${ targetId }"]` );

	if ( typeof toggle === 'undefined' ) {
		// Toggle based on target's hidden status
		toggle = target.getAttribute( 'aria-hidden' ) === 'true';
	}

	// Update the controls if applicable
	controls.forEach( control => {
		if ( control.hasAttribute( 'aria-expanded' ) ) {
			control.setAttribute( 'aria-expanded', toggle );
		}
	} );

	// Hide/show the target
	target.setAttribute( 'aria-hidden', ! toggle );
	if ( toggle ) {
		// If target is meant to be focused (is tabble or has explicit tabindex)
		if ( target.tabIndex > 0 || target.hasAttribute( 'tabindex' ) ) {
			target.focus();
		} else {
			// Find the first focusable element within and focus that
			const focusable = [ ...target.querySelectorAll( FOCUSABLES_SELECTOR ) ].find( isElementFocusable );
			if ( focusable ) {
				focusable.focus();
			}
		}
	}

	return toggle;
}
